module.exports = { apiServer: 'https://api.uat2.intimex.hk', AdminServer: 'https://admin.uat2.intimex.hk' };
